import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import ReactModal from 'react-modal';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import styles from '../../../../styles/case/Modal.module.scss';
import buttonStyles from '../../../../styles/base_components/Button.module.scss';

const customStyles = {
  content: {
    maxWidth: 'calc(100vw - 200px)',
    maxHeight: 'calc(100vh - 100px)',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    border: 'none',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#303253',
    boxShadow: '#282840 0px 5px 15px'
  },
  overlay: {
    zIndex: 2,
    backgroundColor: 'rgba(40, 40, 46, 0.3)'
  }
};

function NoteDialog(props) {
  const [isPublic, setIsPublic] = useState(false);
  const [noteText, setNoteText] = useState('');

  useEffect(() => {
    if (props.show) {
      setIsPublic(props.crtNote?.is_public || false);
      setNoteText(props.crtNote?.content || '');
    }
  }, [props.show, props.crtNote])

  function save() {
    const newNote = { ...props.crtNote, is_public: isPublic, content: noteText };
    props.onSave(newNote);
  }

  function deleteNote() {
    const id = props.crtNote?.id;
    if (!id) return;
    props.onDelete && props.onDelete(props.crtNote);
  }

  // TODO: CSS fix: note dialog is behind aside (aside has z-index=1)
  return (
    <ReactModal isOpen={props.show} onRequestClose={props.onCancel} style={customStyles}>
      <div className={styles.modal}>
        <div className={styles.exit} onClick={props.onCancel} />
        <div style={{ color: 'white', width: '100%' }}>
          <h2>{props.crtNote?.id ? 'Edit note' : 'Add note'}</h2>
          <div style={{ marginTop: '10px', width: '450px' }}>
            <FormGroup>
              <TextField margin="dense" label="Node type" disabled required variant="filled" size="small" value={props.crtNote?.node_type || ''} />
              <TextField margin="dense" label="Node value" disabled required variant="filled" size="small" value={props.crtNote?.node_value || ''} />

              <TextField margin="dense" label="Note" multiline required autoFocus maxRows={10} minRows={4} value={noteText} onChange={e => setNoteText(e.target.value)} />
              <FormControlLabel control={
                <Checkbox checked={isPublic} inputProps={{ 'aria-label': 'controlled' }} onChange={(evt) => setIsPublic(evt.target.checked)} />
              } label="Shared (make the note visible to all users)" />
            </FormGroup>
            {props.otherParams?.errorMsg &&
              <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                {props.otherParams.errorMsg}
              </Alert>
            }
          </div>
        </div>
        <Stack direction="row" spacing={2}>
          <Button color="success" disabled={props.otherParams?.loading} onClick={save}>Save</Button>
          {props.crtNote?.id && <Button color="error" disabled={props.otherParams?.loading} onClick={deleteNote}>Delete</Button>}
          <Button disabled={props.otherParams?.loading} onClick={props.onCancel}>Cancel</Button>
        </Stack>
      </div>
    </ReactModal>
  );
}

export default NoteDialog;
